<template>
  <div class="empty" :style="{height: height+'px'}">
    <a-empty
    :image="image"
    :image-style="{
      height:imgHeight+'px' ,
    }"
  >
    <span slot="description">{{desc}}</span>
  </a-empty>
  </div>
</template>

<script>
export default {
  name: 'AntdvEmpty',
  props: {
    height:{
      type: Number,
      default:300
    },
    desc:{
      type:String,
      default:"暂无数据"
    },
    image:{
      type:String,
      // default:"https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
    },
    imgHeight:{
      type:Number,
      default:60
    }
  },
  data() {
    return {

    }
  },
  components: {},
  mounted() {},
  methods: {
    
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.empty{
    padding-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/public/AntdvEmpty.vue